import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { GetAllReminders, GetRemindersToday, CreateReminder, ClearReminderAlerts, DeleteReminder, UpdateReminder, DismissReminderAlert, CreateReminderAlert } from 'app/store/reminder/reminder.actions';
import { ReminderState } from 'app/store/reminder/reminder.state';
import { Observable } from 'rxjs';
import { Reminder } from 'app/models/dto/reminder.model';
import { NewReminderForm } from 'app/models/dto/new-reminder.model';
import { Alert } from 'app/models/dto/alert.model';
import { CreateNewBorrowerAlert } from 'app/store/borrower/alerts/borrower-alerts.actions';

@Component({
  selector: 'app-schedule-reminder-smart',
  templateUrl: './schedule-reminder-smart.component.html',
  styleUrls: ['./schedule-reminder-smart.component.scss'],
  standalone: false
})
export class ScheduleReminderSmartComponent implements OnInit, OnDestroy {

  @Select(ReminderState.allReminders) allReminders$: Observable<Reminder[]>;
  @Select(ReminderState.allRemindersLoaded) allRemindersLoaded$: Observable<boolean>;
  @Select(ReminderState.alerts) alerts$: Observable<boolean>;
  @Input() view: 'full' | 'borrower' = 'full';
  @Input() borrowerId: number;
  @Output() closeMenu = new EventEmitter();

  constructor(private store: Store) { }

  ngOnInit(): void {
    if (this.view === 'full') {
      this.store.dispatch(new GetAllReminders());
    } else {
      this.store.dispatch(new GetRemindersToday());
    }
  }

  ngOnDestroy(): void {
    this.store.dispatch(new ClearReminderAlerts());
  }

  createNewReminder(newReminder: NewReminderForm) {
    const reminder = newReminder;
    if (!reminder.borrowerId) {
      reminder.borrowerId = this.borrowerId;
    }
    this.store.dispatch(new CreateReminder(reminder));
    this.closeMenu.emit();
  }

  cancelReminder(reminderId: number) {
    this.store.dispatch(new DeleteReminder(reminderId));
  }

  completeReminder(reminderId: number) {
    this.store.dispatch(new UpdateReminder(reminderId, { occurred: 1 }));
  }

  rescheduleReminder(updatedReminder: { reminderId: number, updates: NewReminderForm }) {
    this.store.dispatch(new UpdateReminder(updatedReminder.reminderId, updatedReminder.updates));
  }

  newReminderAlert(alert: Alert) {
    this.store.dispatch(new CreateReminderAlert(alert));
  }

  newReminderBorrowerAlert(alert: Alert) {
    this.store.dispatch(new CreateNewBorrowerAlert(alert));
  }


  closeReminder() {
    this.closeMenu.emit();
  }

  dismissAlert(alert: Alert) {
    this.store.dispatch(new DismissReminderAlert(alert));
  }
}
